<template>
	<div class="chart">
		<div class="left_tab">
			<div style="padding: 20px 10px">
				<p class="list_title">会话列表</p>
				<div class="flex_between">
					<div class="line_up flex_center">
						<span> 已接待 </span>
						<span> {{ customer.kefuReception }} </span>
					</div>
					<div class="line_up flex_center">
						<span> 排队中 </span>
						<span> {{ customer.currentUserLineup }} </span>
					</div>
				</div>
			</div>
			<div class="replay_list">
				<div
					class="flex_common"
					style="flex-direction: column; margin-top: 20px"
					v-if="userList.length == 0 || upmeeting"
				>
					<img
						style="width: 40px; height: 40px"
						src="../../assets/none_thing/ChatDotRoun.png"
						alt=""
					/>
					<p class="none_thing">暂无会话</p>
				</div>
				<div v-else>
					<div
						class="replay_list_item"
						v-for="(item, index) in userList"
						:key="index"
						@click="changeUser(item.uId, index, item.dialogueId)"
						:style="{ background: userId == item.uId ? '#F7F7F7' : '#fff' }"
					>
						<div class="item_name flex_between">
							<span class="user_nickname">{{ item.name }}</span>
							<div class="flex_between">
								<span class="item_content">{{ dayjs(item.time).format("YYYY-MM-DD HH:mm") }}</span>
								<span class="message_icon" v-if="item.showIcon"></span>
								<span class="message_icon" style="background: transparent" v-else></span>
							</div>
						</div>
						<div class="item_content" v-if="item.messageType==2">
							[图片]
						</div>
						<div class="item_content" v-else v-html="item.content"></div>
					</div>
				</div>
				<div class="bottom_btn flex_between" v-if="!upmeeting">
					<div v-throttle="downLine" class="btn_down flex_center" style="background: #ff5b5b">
						下线
					</div>
					<div
						v-throttle="noReceive"
						class="btn_down flex_center"
						style="background: #a15bff; margin-left: 20px"
					>
						{{ reception == 1 ? "暂时离开" : "开启会话" }}
					</div>
				</div>
				<!-- <div @click="upline">立即上线</div> -->
			</div>
		</div>
		<div class="middle_detail" :class="upmeeting ? 'flex_center' : ''">
			<div v-if="upmeeting" style="text-align: center">
				<img style="width: 40px; height: 46px" src="../../assets/none_thing/up_line.png" alt="" />
				<div @click="upline" class="up_btn">立即上线</div>
			</div>
			<div v-else style="flex: 1;">
				<div v-for="item in userList" :key="item.uId">
					<div v-show="item.uId == userId">
						<ChartWindow
							:key="item.uId"
							:nickname="nickname"
							@updateData="handleUpdateData"
							@endSession="endMeet"
							ref="refChartWindow"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="right_tab">
			<RightTab ref="refRightTab" :showReply="true" :showEmpty="showEmpty" @copyReplay="getCopy" />
		</div>
	</div>
</template>

<script setup>
import { ref, onActivated, onMounted, getCurrentInstance, onBeforeUnmount } from "vue";
import RightTab from "@/components/RightTab.vue";
import router from "../../router/index";
import { useRoute } from "vue-router";
import { get } from "../../utils/request";
import ChartWindow from "@/components/ChartWindow.vue";
import { createPacket, encode, decode } from "@/utils/codec.js";
import Command from "@/utils/command.js";
import dayjs from "dayjs";
// import Notify from "@wcjiang/notify";
import { ElMessage } from "element-plus";
// src/eventBus.js
import mitter from "@/utils/mitt";
const upmeeting = ref(true);
const refRightTab = ref(null);
const refChartWindow = ref(null);
const socket = ref(null);
const userId = ref();
const showEmpty = ref(true);
const boxIndex = ref(-1);
const nickname = ref("");
const customer = ref({});
const token = ref(sessionStorage.customer_token);
const reception = ref(1);
const userList = ref([]);
const timer = ref(null);
const dialogueId = ref("");
const route = useRoute();
const active = ref(""); //判断是否在前台后台
const notify = ref(null);
const workers = ref(null);
const { proxy } = getCurrentInstance();
onMounted(() => {
	sessionStorage.setItem("down_line", "down");
	// notify.value = new Notify({
	// 	title: "JJ Federation CS Platform",
	// 	effect: "scroll",
	// 	disableFavicon: true,
	// });
	// notify.value.setInterval(200);
});
onActivated(() => {
	getCustomer();
	if (!upmeeting.value) {
		upline();
	}
});
onBeforeUnmount(() => {
	// notify.value.setTitle();
	if (timer.value) {
		clearInterval(timer.value);
		document.removeEventListener("visibilitychange", VisibilityChange);
	}
});

const VisibilityChange = () => {
	if (document.visibilityState === "visible") {
		active.value = "visible";
		// console.log("回来");
		if (timer.value) {
			clearInterval(timer.value);
		}
		if (!upmeeting.value) {
			upline();
		}
	}
	if (document.visibilityState == "hidden") {
		// console.log("离开");
		active.value = "hidden";
		// if (timer.value) {
		// 	clearInterval(timer.value);
		// }
	}
};
//防抖
const debounce = (func, delay) => {
	let timer;

	return function () {
		if (!timer) {
			func.apply(this, arguments);

			timer = setTimeout(() => {
				timer = null;
			}, delay);
		}
	};
};
const suportNotify = () => {
	if (window.Notification) {
		// 支持
		//如果支持Web Notifications API，再判断浏览器是否支持弹出实例
		showMess();
	} else {
		// 不支持
		alert("不支持 Web Notifications API");
	}
};
//判断浏览器是否支持弹出实例
const showMess = () => {
	if (window.Notification && Notification.permission !== "denied") {
		//Notification.requestPermission这是一个静态方法，作用就是让浏览器出现是否允许通知的提示
		Notification.requestPermission(function (status) {
			//如果状态是同意
			if (status === "granted") {
				if (notify.value) {
					notify.value.close();
				}
				notify.value = new Notification("JJ客服", {
					body: "有新消息，请快速回复", //消息体内容
					// icon: "" //消息图片
				});
				notify.value.onclick = function () {
					//点击当前消息提示框后，跳转到当前页面
					window.focus();
				};
			} else {
				alert("暂无通知权限，请前往设置，隐私与安全，网页设置，打开本网页通知");
			}
		});
	} else {
		alert("暂无通知权限，请前往设置，隐私与安全，网页设置，打开本网页通知");
	}
};
const showMessDebounced = debounce(function () {
	suportNotify();
	// mitter.emit("message", "【新消息】JJ Federation CS Platform");
	document.title = "【新消息】JJ Federation CS Platform";
}, 3000);

//客服上线
const upline = () => {
	// workers.value && workers.value.terminate();
	// workers.value = null;
	// workers.value = new Worker("./worker.js");
	// workers.value.onmessage = function (event) {
	// 	console.log('666');
	// };

	// return;
	socket.value && socket.value.close();
	socket.value = null;
	if (notify.value) {
		notify.value.close();
	}
	document.removeEventListener("visibilitychange", VisibilityChange);
	// socket.value = new WebSocket("wss://test.sanctuarytech.co:8020/orota");
	socket.value = new WebSocket("wss://cs.vip.jjlin.tech:8020/orota");
	socket.value.binaryType = "arraybuffer";
	socket.value.onopen = function (event) {
		document.addEventListener("visibilitychange", VisibilityChange);
		if (route.path == "/Chart") {
			// mitter.emit("message", "JJ Federation CS Platform");
			document.title = "JJ Federation CS Platform";
		}

		sessionStorage.setItem("down_line", "up");
		if (timer.value) {
			clearInterval(timer.value);
		}
		loginNetty();
		timer.value = setInterval(() => {
			const data = {
				token: token.value,
				userType: 1,
			};
			// console.log("心跳");
			if (socket.value.readyState === WebSocket.OPEN) {
				socket.value.send(encode(createPacket(data, Command.HEART_BEAT_REQUEST)));
			} else {
				if (active.value == "hidden") {
					upline();
				}
			}
		}, 20000);
	};
	socket.value.onmessage = function (event) {
		upmeeting.value = false;

		const message = decode(event.data);
		const userIndex = userList.value.findIndex((item) => item.uId == message.uId);
		// console.log("接收到消息", message);
		//用户断开
		if (message.type == 0) {
			userList.value.splice(userIndex, 1);
			if (userList.value.length == 0) {
				userId.value = "";
				boxIndex.value = -1;
				dialogueId.value = "";
			}
			const index = userList.value.findIndex((item) => item.uId == userId.value);

			if (index != -1) {
				setTimeout(() => {
					refChartWindow.value[index].getHistoryRecord(userId.value, dialogueId.value);
					refRightTab.value.getUserInfo(userId.value);
					boxIndex.value = index;
				}, 0);
			} else {
				showEmpty.value = true;
				userId.value = "";
				boxIndex.value = -1;
				dialogueId.value = "";
			}
			getCustomer();
		}
		//排队
		if (message.type == 1) {
		}
		//分配成功
		if (message.type == 2) {
			//会话
			const hasUser = userList.value.some((item) => item.uId == message.uId);
			if (!hasUser) {
				userList.value.push({
					uId: message.uId,
					name: message.nickname,
					content: "",
					dialogueId: message.dialogueId,
					showIcon: true,
					time: message.time,
					messageType: message.messageType,
				});
				getCustomer();
			}
		}
		//会话
		if (message.type === 3) {
			refChartWindow.value[userIndex].pushUserMessage(message);
			userList.value[userIndex].content = message.msg;
			userList.value[userIndex].messageType = message.messageType;
			userList.value[userIndex].time = message.time;
			userList.value[userIndex].dialogueId = message.dialogueId;
			dialogueId.value = userList.value[userIndex].dialogueId;
			if (active.value === "hidden" || route.name != "Chart") {
				// notify.value.setTitle("【新消息】JJ Federation CS Platform");

				showMessDebounced();
			}

			if (message.uId == userId.value) {
				userList.value[userIndex].showIcon = false;
				const data = {
					userId: userId.value,
					token: token.value,
				};
				socket.value.send(encode(createPacket(data, Command.MESSAGE_READ_REQUEST)));
			} else {
				userList.value[userIndex].showIcon = true;
			}
		}
		if (message.type == 4) {
			reception.value = message.service;
		}
		//重新接连
		if (message.type == 6) {
			reception.value = message.service;
			userList.value = message.sessionList.map((item) => {
				return {
					uId: item.userId,
					name: item.nickname,
					content: item.dialogue.content,
					dialogueId: item.dialogue.id,
					time: item.dialogue.createTime,
					showIcon: item.unread > 0 ? true : false,
					messageType: item.dialogue.messageType,
				};

			});
			const index = userList.value.findIndex((item) => item.uId == userId.value);

			if (index != -1) {
				setTimeout(() => {
					refChartWindow.value[index].getHistoryRecord(userId.value, dialogueId.value);
					refRightTab.value.getUserInfo(userId.value);
					boxIndex.value = index;
				}, 0);
			} else {
				showEmpty.value = true;
				userId.value = "";
				boxIndex.value = -1;
				dialogueId.value = "";
			}
			getCustomer();
		}
		//token失效
		if (message.type == 8) {
			sessionStorage.clear();
			clearInterval(timer.value);
			ElMessage({
				message: "token失效，请重新登录",
				type: "error",
			});
			document.removeEventListener("visibilitychange", VisibilityChange);
			router.replace("/Login");
		}
		//客服会话id
		if (message.type == 9) {
			userList.value[userIndex].dialogueId = message.dialogueId;
			dialogueId.value = message.dialogueId;
		}
		if (message.type == 10) {
			// console.log(event);
		}
	};
	socket.value.onclose = function (event) {
		console.log("连接断开");
	};
};

//结束会话
const endMeet = () => {
	// console.log("结束会话");
	if (timer.value) {
		clearInterval(timer.value);
	}
	const data = {
		token: token.value,
		userType: 1,
		userId: userId.value,
	};
	socket.value.send(encode(createPacket(data, Command.CLOSE_SESSION_REQUEST)));
	const userIndex = userList.value.findIndex((item) => item.uId === userId.value);
	if (userIndex !== -1) {
		userList.value.splice(userIndex, 1);
		showEmpty.value = true;
		userId.value = "";
		document.title = "JJ Federation CS Platform";
	}
	getCustomer();
};
//下线
const downLine = () => {
	if (userList.value.length > 0) {
		ElMessage({
			message: "还有对话尚未结束，请处理完所有对话后再尝试下线",
			type: "error",
		});
		return;
	}
	upmeeting.value = true;
	userList.value = [];
	const data = {
		token: token.value,
		userType: 1,
	};
	socket.value.send(encode(createPacket(data, Command.LOGOUT_REQUEST)));
	socket.value.close();
	sessionStorage.setItem("down_line", "down");
	clearInterval(timer.value);
};

//发送快捷回复
const getCopy = (text) => {
	if (boxIndex.value === -1) {
		return;
	}
	refChartWindow.value[boxIndex.value].copyText(text);
};
//获取排队人数
const getCustomer = () => {
	get(`/api-cms/reception/report`, {}, false).then((res) => {
		if (res.code == 1) {
			customer.value = res.result;
		}
	});
};
const loginNetty = () => {
	if (socket.value && socket.value.readyState === WebSocket.OPEN) {
		const data = {
			token: token.value,
			userType: 1,
		};

		socket.value.send(encode(createPacket(data, Command.LOGIN_REQUEST)));
		// socket.value.send(encode(createPacket({ token: token.value }, Command.HEART_BEAT_REQUEST)));
	}
};
const changeUser = (id, index, dialogue) => {
	nickname.value = userList.value[index].name;
	boxIndex.value = index;
	showEmpty.value = false;
	dialogueId.value = dialogue;
	userList.value[index].showIcon = false;
	if (userId.value != id) {
		refChartWindow.value[index].getHistoryRecord(id, dialogue);
		refRightTab.value.getUserInfo(id);
	}
	userId.value = id;
	const data = {
		userId: id,
		token: token.value,
	};
	socket.value.send(encode(createPacket(data, Command.MESSAGE_READ_REQUEST)));
};
// 发送消息
const handleUpdateData = (data) => {
	const params = {
		token: token.value,
		userType: 1,
		userId: userId.value,
		message: data.text,
		richText: 0,
		messageType: data.messageType,
	};
	socket.value.send(encode(createPacket(params, Command.MESSAGE_REQUEST)));
};
//暂不接待
const noReceive = () => {
	const e = reception.value == 1 ? 0 : 1;
	reception.value = e;
	const params = {
		token: token.value,
		service: e,
	};
	socket.value.send(encode(createPacket(params, Command.UPDATE_SERVICE_REQUEST)));
};
</script>

<style scoped lang="less">
.commonflex {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.chart {
	display: flex;
	justify-content: space-between;
	height: calc(100vh - 100px);
	// background: #cc1616;
	overflow: hidden;
	.left_tab {
		width: 260px;
		height: 100%;
		box-sizing: border-box;
		background: #ffffff;
		border-right: 1px solid #dedede;
		position: relative;
		.list_title {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			line-height: 22px;
			text-align: center;
		}
		.line_up {
			width: 115px;
			height: 42px;
			background: linear-gradient(272deg, #a15bff 0%, #6b31fe 100%), #d9d9d9;
			border-radius: 4px;
			margin-top: 10px;
			color: #ffffff;
			font-size: 14px;
		}
	}
	.replay_list {
		border-top: 1px solid #dedede;
	}
	.replay_list_item {
		cursor: pointer;
		padding: 10px;
		height: 69px;
		box-sizing: border-box;
		.item_name {
			font-size: 14px;
			color: #333333;
			.message_icon {
				width: 10px;
				height: 10px;
				background: #ff4040;
				border-radius: 50%;
				margin-left: 10px;
			}
			.user_nickname {
				width: 50%;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.item_content {
			font-size: 14px;
			color: #b7b7b7;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			:deep(p) {
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				font-size: 14px;
			}
		}
	}
	.middle_detail {
		height: 100%;
		// width: 100%;
		flex: 1;
		background-color: #f7f7f7;
	}
	.right_tab {
		overflow: auto;
		margin-left: 20px;
	}
}
.none_thing {
	font-size: 14px;
	color: #999999;
	line-height: 22px;
}
.up_btn {
	width: 136px;
	height: 42px;
	background: #a15bff;
	border-radius: 4px;
	text-align: center;
	line-height: 42px;
	margin-top: 40px;
	color: #ffffff;
	font-size: 14px;
	cursor: pointer;
}
.bottom_btn {
	left: 20px;
	position: absolute;
	bottom: 20px;
	.btn_down {
		width: 100px;
		height: 32px;
		cursor: pointer;
		border-radius: 4px;
		font-size: 14px;
		color: #ffffff;
		line-height: 22px;
	}
}
</style>
